// src/routes/Routes.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../components/home/Home";
import MeetTheTeam from "../components/meet-the-team/MeetTheTeam";
import MainLayout from "../components/MainLayout";
import Services from "../components/services/Services";
import Events from "../components/events/Events";
import EventDetails from "../components/events/EventDetails";
import Reviews from "../components/reviews/Reviews";
import Login from "../components/admin/Login";
import AdminDashboard from "../components/admin/AdminDashboard";
import ProtectedRoute from "../components/ProtectedRoute";
import AdminServices from "../components/admin/AdminServices";
import EditService from "../components/admin/EditService";
import AdminEvents from "../components/admin/AdminEvents";
import EditEvents from "../components/admin/EditEvents";
import AdminTeamMembers from "../components/admin/AdminTeamMembers";
import EditTeamMembers from "../components/admin/EditTeamMembers";
import AdminImages from "../components/admin/AdminImages";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/"
        element={
          <MainLayout>
            <Home />
          </MainLayout>
        }
      />
      <Route
        path="/services"
        element={
          <MainLayout>
            <Services />
          </MainLayout>
        }
      />
      <Route
        path="/events"
        element={
          <MainLayout>
            <Events />
          </MainLayout>
        }
      />
      <Route
        path="/event/:id"
        element={
          <MainLayout>
            <EventDetails />
          </MainLayout>
        }
      />
      <Route
        path="/meet-the-team"
        element={
          <MainLayout>
            <MeetTheTeam />
          </MainLayout>
        }
      />
      <Route
        path="/reviews"
        element={
          <MainLayout>
            <Reviews />
          </MainLayout>
        }
      />
      <Route
        path="/login"
        element={
          <MainLayout>
            <Login />
          </MainLayout>
        }
      />

      {/* Protected Admin Routes */}
      <Route path="/admin" element={<ProtectedRoute />}>
        <Route
          path="dashboard"
          element={
            <MainLayout>
              <AdminDashboard />
            </MainLayout>
          }
        />
        <Route
          path="services"
          element={
            <MainLayout>
              <AdminServices />
            </MainLayout>
          }
        />
        <Route
          path="services/edit/:id"
          element={
            <MainLayout>
              <EditService />
            </MainLayout>
          }
        />
        <Route
          path="events"
          element={
            <MainLayout>
              <AdminEvents />
            </MainLayout>
          }
        />
        <Route
          path="events/edit/:id"
          element={
            <MainLayout>
              <EditEvents />
            </MainLayout>
          }
        />
        <Route
          path="team"
          element={
            <MainLayout>
              <AdminTeamMembers />
            </MainLayout>
          }
        />
        <Route
          path="team/edit/:id"
          element={
            <MainLayout>
              <EditTeamMembers />
            </MainLayout>
          }
        />
        <Route
          path="images"
          element={
            <MainLayout>
              <AdminImages />
            </MainLayout>
          }
        />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
